import { render, staticRenderFns } from "./VideoBubbleMenu.vue?vue&type=template&id=b6c5bec6&scoped=true"
import script from "./VideoBubbleMenu.vue?vue&type=script&lang=js"
export * from "./VideoBubbleMenu.vue?vue&type=script&lang=js"
import style0 from "./VideoBubbleMenu.vue?vue&type=style&index=0&id=b6c5bec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c5bec6",
  null
  
)

export default component.exports